"use strict";
function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
export default function newDateFromString(dateString) {
  if (!isSafari()) return new Date(dateString);
  return new Date(dateString.replace(/^(\d{4})-(\d{2})-(\d{2})/, "$1/$2/$3"));
}
;
